// Helpers compartidos por la campana (Nav) y la vista de Notificaciones
export const EXT_PERMITIDAS = [
  "png", "jpg", "jpeg", "webp", "gif", "pdf", "doc", "docx", "xls", "xlsx", "txt", "csv",
];
export const MAX_ARCHIVOS = 5;
export const MAX_BYTES = 5 * 1024 * 1024;

// Administrar avisos (crear, editar, eliminar) exige este rol Y este permiso.
// El permiso es el que valida la API; el rol y el permiso juntos muestran los botones en pantalla.
export const ROL_ADMIN_AVISOS = "psp.config.avisos.admin";
export const PERMISO_ADMIN_AVISOS = "psp.admin.avisos";

const dos = (n) => String(n).padStart(2, "0");

// "dd/mm/aaaa hh:mm" en hora local; si solo hay fecha_implementacion, "dd/mm/aaaa"
export function fechaCreacion(aviso) {
  if (!aviso) return "";
  if (aviso.fecha_creacion) {
    const d = new Date(aviso.fecha_creacion);
    if (!isNaN(d)) {
      return `${dos(d.getDate())}/${dos(d.getMonth() + 1)}/${d.getFullYear()} ${dos(d.getHours())}:${dos(d.getMinutes())}`;
    }
  }
  if (aviso.fecha_implementacion) {
    const [y, m, d] = aviso.fecha_implementacion.substring(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }
  return "";
}

// Fecha base del aviso (creacion; cae a implementacion en avisos viejos)
export function fechaBase(aviso) {
  return (aviso && (aviso.fecha_creacion || aviso.fecha_implementacion)) || "";
}

export function formatTamano(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function extension(nombre) {
  const i = String(nombre || "").lastIndexOf(".");
  return i < 0 ? "" : nombre.substring(i + 1).toLowerCase();
}

// Color del icono segun el tipo de archivo (tonos suaves)
export function colorArchivo(archivo) {
  const e = extension(archivo && archivo.nombre);
  if (e === "pdf") return "#c75b5b";
  if (e === "doc" || e === "docx") return "#5b7fb5";
  if (e === "xls" || e === "xlsx" || e === "csv") return "#5b9a7c";
  return "#78909c";
}

// Icono segun el adjunto { nombre, es_imagen }
export function iconoArchivo(archivo) {
  if (!archivo) return "mdi-bullhorn-outline";
  if (archivo.es_imagen) return "mdi-file-image-outline";
  const e = extension(archivo.nombre);
  if (e === "pdf") return "mdi-file-pdf-box";
  if (e === "doc" || e === "docx") return "mdi-file-word";
  if (e === "xls" || e === "xlsx" || e === "csv") return "mdi-file-excel";
  return "mdi-file-outline";
}

// Icono del avatar sin imagen: megafono, o el del primer adjunto
export function iconoAvatar(aviso) {
  const a = archivosDe(aviso)[0];
  return a ? iconoArchivo(a) : "mdi-bullhorn-outline";
}

// Circulo de la derecha: { icono, clase } segun el tipo del aviso
export function tipoAviso(aviso) {
  const arch = archivosDe(aviso);
  if (arch.some((a) => a.es_imagen)) return { icono: "mdi-image-outline", clase: "tipo-img" };
  const e = extension(arch[0] && arch[0].nombre);
  if (e === "pdf") return { icono: "mdi-file-pdf-box", clase: "tipo-pdf" };
  if (e === "doc" || e === "docx") return { icono: "mdi-file-word", clase: "tipo-doc" };
  if (e === "xls" || e === "xlsx" || e === "csv") return { icono: "mdi-file-excel", clase: "tipo-xls" };
  if (arch.length) return { icono: "mdi-file-outline", clase: "tipo-doc" };
  return { icono: "mdi-bell-outline", clase: "tipo-txt" };
}

export function archivosDe(aviso) {
  return (aviso && Array.isArray(aviso.archivos) ? aviso.archivos : []).filter(Boolean);
}

// Primera imagen del aviso (o undefined)
export function primeraImagen(aviso) {
  return archivosDe(aviso).find((a) => a.es_imagen);
}
